import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * usePageContent - Fetches dynamic page content from the backend.
 * Returns an object where keys are the content field names.
 * Falls back to an empty object if loading fails.
 *
 * @param {string} pageSlug - The page slug (e.g., 'home', 'precios')
 * @returns {{ content: object, loading: boolean }}
 */
const usePageContent = (pageSlug) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pageSlug) { setLoading(false); return; }
    fetch(`${API_URL}/api/public/pages/${pageSlug}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.content) setContent(d.content); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageSlug]);

  // Helper: returns dynamic value if set, otherwise returns the fallback
  const get = (key, fallback = '') => content[key] || fallback;

  return { content, loading, get };
};

export default usePageContent;
